module.exports = __webpack_public_path__ + "static/media/gu.750528ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gu.png
// module id = 1870
// module chunks = 0